import { buildSearchEngine } from '@coveo/headless';

const postprocessSearchResponse = response => {
  response.body?.results.forEach(result => result);
  return response;
};

const postprocessFacetSearchResponse = response => {
  return response;
};

const postprocessQuerySuggestSearchResponse = response => {
  return response;
};

const preprocessRequest = (request, clientOrigin) => {
  if (global.preProcessRequest) {
    if (clientOrigin === 'searchApiFetch' && request.body) {
      const body = global.preProcessRequest(request.body.toString());
      request.body = body;
    }
  }

  if (clientOrigin === 'analyticsFetch') {
    // E.g., send data to a third party
  }

  return request;
};

const buildEngine = ({ organizationId, accessToken, searchHub, pipeline }) => {
  const headlessEngine = buildSearchEngine({
    configuration: {
      organizationId: organizationId,
      accessToken: accessToken,
      search: {
        searchHub: searchHub,
        pipeline: pipeline,
        preprocessSearchResponseMiddleware: postprocessSearchResponse,
        preprocessFacetSearchResponseMiddleware: postprocessFacetSearchResponse,
        preprocessQuerySuggestResponseMiddleware:
          postprocessQuerySuggestSearchResponse
      },
      analytics: {
        originLevel3: document.referrer ? document.referrer : 'no-referrer'
      },
      preprocessRequest
    }
  });

  return headlessEngine;
};

const commonConfigurator = document.querySelector(
  '.coveo-common-engine-configurator'
);

const coveoCommonConfig = {};
let commonEngine = null;

if (commonConfigurator) {
  coveoCommonConfig.organizationId =
    commonConfigurator.dataset.coveoOrganizationId;
  coveoCommonConfig.accessToken = commonConfigurator.dataset.coveoAccessToken;
  coveoCommonConfig.searchHub = commonConfigurator.dataset.coveoSearchHub;
  coveoCommonConfig.pipeline = commonConfigurator.dataset.coveoPipeline;

  commonEngine = buildSearchEngine({
    configuration: {
      organizationId: coveoCommonConfig.organizationId,
      accessToken: coveoCommonConfig.accessToken,
      search: {
        searchHub: coveoCommonConfig.searchHub,
        pipeline: coveoCommonConfig.pipeline,
        preprocessSearchResponseMiddleware: postprocessSearchResponse,
        preprocessFacetSearchResponseMiddleware: postprocessFacetSearchResponse,
        preprocessQuerySuggestResponseMiddleware:
          postprocessQuerySuggestSearchResponse
      },
      analytics: {
        originLevel3: document.referrer ? document.referrer : 'no-referrer'
      },
      preprocessRequest
    }
  });
}

const nearbyColumnHeadless = document.querySelector(
  '.nearby-communities-supporting-column-headless > div'
);

const nearbyColumnEngineConfig = {};
let nearbyColumnEngine = null;

if (nearbyColumnHeadless) {
  nearbyColumnEngineConfig.organizationId =
    nearbyColumnHeadless.dataset.coveoOrganizationId;
  nearbyColumnEngineConfig.accessToken =
    nearbyColumnHeadless.dataset.coveoAccessToken;
  nearbyColumnEngineConfig.searchHub =
    nearbyColumnHeadless.dataset.coveoSearchHub;
  nearbyColumnEngineConfig.pipeline =
    nearbyColumnHeadless.dataset.coveoPipeline;

  nearbyColumnEngine = buildSearchEngine({
    configuration: {
      organizationId: nearbyColumnEngineConfig.organizationId,
      accessToken: nearbyColumnEngineConfig.accessToken,
      search: {
        searchHub: nearbyColumnEngineConfig.searchHub,
        pipeline: nearbyColumnEngineConfig.pipeline,
        preprocessSearchResponseMiddleware: postprocessSearchResponse,
        preprocessFacetSearchResponseMiddleware: postprocessFacetSearchResponse,
        preprocessQuerySuggestResponseMiddleware:
          postprocessQuerySuggestSearchResponse
      },
      analytics: {
        originLevel3: document.referrer ? document.referrer : 'no-referrer'
      },
      preprocessRequest
    }
  });
}

export { buildEngine, commonEngine, nearbyColumnEngine };
